'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _instafeed = require('instafeed.js');

var _instafeed2 = _interopRequireDefault(_instafeed);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

require('../../styles/sections/index-instagram.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('index-instagram', {
  onLoad: function onLoad() {
    var container = this.container;
    var feed = (0, _jquery2.default)(container).find('[data-instagram-feed]');
    var limit = feed.data('limit');
    var token = feed.data('token');
    var user = feed.data('user');
    var target = 'instagram_feed_' + (0, _jquery2.default)(feed).data('id');

    var settings = (0, _slick2.default)({
      slidesToShow: limit,
      slidesToScroll: limit,
      prevArrow: (0, _jquery2.default)(container).find('[data-slick-prev]'),
      nextArrow: (0, _jquery2.default)(container).find('[data-slick-next]'),
      responsive: [{
        breakpoint: Breakpoints['small'],
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          appendArrows: (0, _jquery2.default)(feed).closest('.slick-slider-wrapper').find('.slick-arrows'),
          arrows: true
        }
      }]
    });

    this.instagram = new _instafeed2.default({
      get: 'user',
      userId: user,
      accessToken: token,
      target: target,
      limit: limit,
      resolution: 'standard_resolution',
      after: function after() {
        feed.slick(settings);
      },
      template: '<div class="insta-gram"><a class="block" href="{{link}}" target="_blank" rel="nofollow"><div class="background-image" data-ratio="1:1" style="background-image:url({{image}})"><img src="{{image}}" alt="{{caption}}"/></div></a></div>'
    });

    this.instagram.run();
  },
  onUnload: function onUnload() {}
});